module.exports = __webpack_public_path__ + "static/media/eat-habit-thumbnail.ee9b9996.png";